import React, { useEffect, useState } from "react";
import "./Products.css";
import DataTableComponent from "../../components/DataTable";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProductManagementData,
  fetchProductsManagementData,
} from "../../redux/slice/ProductManagementSlice";
import Loader from "../../components/Common/Loader/PrimaryLoader";
import image from "../../Assets/no-img/no-image-icon.png";
import DeleteConFirmationModal from "../../components/Common/DeleteConFirmationModal";
import InfoModal from "../../components/Common/InfoModal";
import { usePic } from "../../context/PicProvider";
import { RxTriangleDown } from "react-icons/rx";

function Products() {
  const { setIsLoading } = usePic();
  const [userListModal, setUserListModal] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [modalConfirmTitle, setModalConfirmTitle] = useState("");
  const [showDropCon, setShowDropCon] = useState(false);
  const [downDrop, setDownDrop] = useState(false);
  const [customClass, setCustomClass] = useState("");
  const [removeId, setRemoveId] = useState([]);

  const dispatch = useDispatch();
  const { status, ProductManagementData } = useSelector(
    (state) => state.PRODUCTMANAGEMENT
  );

  const clickRowHandler = (row) => {
    setUserInfo(row);
    setUserListModal(true);
  };

  useEffect(() => {
    dispatch(fetchProductsManagementData());
  }, [dispatch]);

  const columns = [
    {
      name: "",
      width: "65px",
      cell: (row) => (
        <img
          src={row.kit_picture}
          className="products-image"
          alt="product-image"
          onError={(e) => {
            e.target.src = image;
          }}
        />
      ),
    },
    {
      name: (
        <span
          className={customClass === "1" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("1")}
        >
          BOM
        </span>
      ),
      width: "150px",
      selector: (row) => row.product_code,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "2" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("2")}
        >
          Product
        </span>
      ),
      minWidth: "250px",
      grow: 1,
      selector: (row) => row.product_name,
      sortable: true,
    },
    {
      width: "250px",
      name: (
        <span
          className={customClass === "3" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("3")}
        >
          Brand
        </span>
      ),
      selector: (row) => row.brand,
      sortable: true,
    },
    // {
    //   name: (
    //     <span
    //       className={customClass === "4" ? "custom-span-style-for-sorting" : ""}
    //       onClick={() => handleCustomClassForUnderLine("4")}
    //     >
    //       Quantity
    //     </span>
    //   ),
    //   width: "170px",
    //   selector: (row) => row.quantity,
    //   sortable: true,
    //   style: {
    //     justifyContent: "center",
    //   },
    // },
  ];
  if (status === "loading") {
    return (
      <div>
        <Loader />
      </div>
    );
  }
  const userData = ProductManagementData || [];

  const handleCustomClassForUnderLine = (num) => {
    setCustomClass(num);
  };

  const downIconHandler = () => {
    setDownDrop(!downDrop);
  };

  const deleteHandler = () => {
    setDeleteConfirm(true);
    setModalConfirmTitle("Are you sure you want to delete this Product ?");
  };

  // const removeProductHandler = async (id) => {
  const removeProductHandler = async () => {
    setIsLoading(true);
    const res = await dispatch(
      deleteProductManagementData({ kitIds: removeId })
    );
    setIsLoading(false);
    if (res?.payload?.status === 200) {
      dispatch(fetchProductsManagementData());
      setDeleteConfirm(false);
      setShowDropCon(false);
      setDownDrop(false);
      setRemoveId([]);
    }
  };

  const onSelectedCheckboxChange = (check) => {
    const selectedId = check?.selectedRows.map((curElm) => curElm._id);
    if (selectedId.length > 0) {
      setRemoveId(selectedId);
      setShowDropCon(true);
    } else {
      setRemoveId([]);
      setShowDropCon(false);
    }
  };
  return (
    <>
      <div className="position-relative flex-grow-1">
        {userData && userData.length > 0 && showDropCon && (
          <div className="dropdown_icon_style">
            <div onClick={() => downIconHandler()}>
              <RxTriangleDown size={23} />
            </div>
            {downDrop && (
              <div className="event-box-data-user-event-listing">
                <h6 className="cursor" onClick={() => deleteHandler()}>
                  Delete
                </h6>
              </div>
            )}
          </div>
        )}
        <DataTableComponent
          search={true}
          searchBy={["product_name", "brand", "product_code"]}
          title={`Registered Available on Tell Arnie`}
          columns={columns}
          data={userData}
          clickedRow={clickRowHandler}
          selectedRows
          checkboxChange={onSelectedCheckboxChange}
          placeholder="Search for product"
        />
      </div>

      {userListModal && (
        <InfoModal
          hide={() => setUserListModal(false)}
          show={userListModal}
          title={"Product Management"}
          listingData={userInfo}
        />
      )}
      {deleteConfirm && (
        <DeleteConFirmationModal
          show={deleteConfirm}
          title={modalConfirmTitle}
          eventHandler={removeProductHandler}
          hide={() => setDeleteConfirm(false)}
        />
      )}
    </>
  );
}

export default Products;
